package com.htmlagent.site.i18n

// Generated from i18n/strings.json. Do not edit: edit the JSON and rebuild.

/** The texts of the errors area. */
interface ErrorsStrings {
    val sessionBusy: String

    val guestLimitReached: String

    val sessionProtected: String

    val sessionNotFound: String

    val versionNotFound: String

    val emptyPrompt: String

    val messageNotFound: String

    val invalidUserId: String

    val storageFailure: String

    val malformedSessionId: String

    val malformedBody: String

    val malformedRequest: String

    val unexpected: String

    val unreachable: String

    val malformedResponse: String

    val connectionLost: String

    val invalidImage: String

    val pageCutShort: String

    val replyCutShort: String

    val notFinished: String

    val timedOut: String

    val notSaved: String

    val generationFailed: String

    val invalidEmail: String

    val tooManyGuests: String

    val tooManyRequests: String

    val mailUnavailable: String

    val invalidLink: String

    val wrongMatch: String

    val notAGuest: String

    val unauthenticated: String
}

/** The errors area in Spanish. */
internal object SpanishErrorsStrings : ErrorsStrings {
    override val sessionBusy: String = "La sesión está ocupada: espera a que termine la página en curso."

    override val guestLimitReached: String = "Has usado todas las peticiones de invitado. Entra con tu correo para seguir: tus páginas vienen contigo."

    override val sessionProtected: String = "Esta página es un ejemplo de la web y no se puede borrar."

    override val sessionNotFound: String = "Esa sesión ya no existe. Empieza una nueva."

    override val versionNotFound: String = "Esa versión de la página ya no está disponible."

    override val emptyPrompt: String = "Cuéntame qué quieres que haga."

    override val messageNotFound: String = "Ese mensaje ya no está en la conversación. Recarga para verla al día."

    override val invalidUserId: String = "Ese correo no es válido."

    override val storageFailure: String = "No se pudo guardar. Vuelve a intentarlo."

    override val malformedSessionId: String = "Esa sesión no se puede abrir. Empieza una nueva."

    override val malformedBody: String = "No se pudo enviar la petición. Vuelve a intentarlo."

    override val malformedRequest: String = "No se pudo enviar la petición. Vuelve a intentarlo."

    override val unexpected: String = "Algo ha fallado por nuestra parte. Vuelve a intentarlo en unos segundos."

    override val unreachable: String = "No hemos podido conectar. Revisa tu conexión a internet y vuelve a intentarlo en unos segundos."

    override val malformedResponse: String = "Algo ha fallado por nuestra parte. Recarga la página y vuelve a intentarlo."

    override val connectionLost: String = "Se ha cortado la conexión. Recarga la página para ver el estado actual."

    override val invalidImage: String = "Una de las fotos no vale: usa JPEG, PNG o WebP, hasta 4 por mensaje."

    override val pageCutShort: String = "La página se cortó antes de terminar. Vuelve a pedírmela."

    override val replyCutShort: String = "La respuesta se cortó por longitud. Vuelve a intentarlo."

    override val notFinished: String = "No conseguí terminar la página. Prueba a pedírmelo de otra forma."

    override val timedOut: String = "La generación tardó demasiado y se detuvo."

    override val notSaved: String = "No se pudo guardar la página."

    override val generationFailed: String = "No se pudo completar la generación."

    override val invalidEmail: String = "Ese correo no parece válido. Revísalo."

    override val tooManyGuests: String = "Se han creado demasiados invitados desde esta red. Entra con tu correo para seguir."

    override val tooManyRequests: String = "Has pedido varios enlaces seguidos. Espera un poco antes de pedir otro."

    override val mailUnavailable: String = "Ahora no podemos enviar el enlace. Puedes seguir como invitado y guardar tus páginas más tarde."

    override val invalidLink: String = "Ese enlace ya no sirve: caducó o ya se usó. Pide otro."

    override val wrongMatch: String = "Ese no era el número. Por seguridad, el enlace ya no sirve: pide otro desde la ventana que espera."

    override val notAGuest: String = "Esa clave no es de invitado."

    override val unauthenticated: String = "Tu sesión ha caducado. Vuelve a entrar."
}

/** The errors area in English. */
internal object EnglishErrorsStrings : ErrorsStrings {
    override val sessionBusy: String = "This session is busy: wait for the page in progress to finish."

    override val guestLimitReached: String = "You have used every guest request. Sign in with your email to go on: your pages come with you."

    override val sessionProtected: String = "This page is one of the site's examples and cannot be deleted."

    override val sessionNotFound: String = "That session no longer exists. Start a new one."

    override val versionNotFound: String = "That version of the page is no longer available."

    override val emptyPrompt: String = "Tell me what you want me to do."

    override val messageNotFound: String = "That message is no longer in the conversation. Reload to see it up to date."

    override val invalidUserId: String = "That email address is not valid."

    override val storageFailure: String = "It could not be saved. Try again."

    override val malformedSessionId: String = "That session cannot be opened. Start a new one."

    override val malformedBody: String = "The request could not be sent. Try again."

    override val malformedRequest: String = "The request could not be sent. Try again."

    override val unexpected: String = "Something went wrong on our side. Try again in a few seconds."

    override val unreachable: String = "We could not connect. Check your internet connection and try again in a few seconds."

    override val malformedResponse: String = "Something went wrong on our side. Reload the page and try again."

    override val connectionLost: String = "The connection dropped. Reload the page to see where things stand."

    override val invalidImage: String = "One of the photos was refused: use JPEG, PNG or WebP, up to 4 per message."

    override val pageCutShort: String = "The page was cut off before it finished. Ask me for it again."

    override val replyCutShort: String = "The answer was cut off for length. Try again."

    override val notFinished: String = "I couldn't finish the page. Try asking me in a different way."

    override val timedOut: String = "The generation took too long and was stopped."

    override val notSaved: String = "The page could not be saved."

    override val generationFailed: String = "The generation could not be completed."

    override val invalidEmail: String = "That email does not look valid. Check it."

    override val tooManyGuests: String = "Too many guests have been started from this network. Sign in with your email to go on."

    override val tooManyRequests: String = "You asked for several links in a row. Wait a little before asking for another."

    override val mailUnavailable: String = "We cannot send the link right now. You can go on as a guest and keep your pages later."

    override val invalidLink: String = "That link no longer works: it expired or was already used. Ask for another."

    override val wrongMatch: String = "That was not the number. To be safe, the link no longer works: ask for another from the waiting window."

    override val notAGuest: String = "That is not a guest key."

    override val unauthenticated: String = "Your session expired. Sign in again."
}
